module.exports = __webpack_public_path__ + "img/bg-bean-02.7316d609.png";